import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CloseGrievanceDialogComponent } from 'src/app/grievance/close-grievance-dialog/close-grievance-dialog.component';
import { CommonFunction } from 'src/app/grievance/common-function';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { ObjectionSuggestionTypeService } from '../objection-suggestion-type.service';

const COLS = [
  { value: "OBJECTION & SUGGESTION TYPE ID", lowercaseValue: "pkOstid", displayName: "Id" },
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "DEPARTMENT", lowercaseValue: "departmentName", displayName: "Department" },
  { value: "OBJECTION/SUGGESTION", lowercaseValue: "osType", displayName: "Objection/Suggestion" },
  { value: "OBJECTION/SUGGESTION TYPE", lowercaseValue: "objectionSuggestion", displayName: "Objection/Suggestion Type" },
];
export interface ObjectionSuggestionList {
  pkOstid: any;
  boardName: any;
  departmentName: any;
  osType: string;
  objectionSuggestion: any;
  createdOn: any;
}
export class ObjectionSuggestionList {
  pkOstid: any;
  boardName: any;
  departmentName: any;
  osType: string;
  objectionSuggestion: any;
  createdOn: any;
}
@Component({
  selector: 'app-list-objection-suggestion',
  templateUrl: './list-objection-suggestion.component.html',
  styleUrls: ['./list-objection-suggestion.component.scss'],
})
export class ListObjectionSuggestionComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  loading = true
  displayedColumns: any[];
  progressSpinnerDialog: any = null;
  objectionSuggestionList: ObjectionSuggestionList[] = [];
  dataSource = new MatTableDataSource(this.objectionSuggestionList);
  noobjectSuggestion=ProjectConstants.objeSuggestionTypeFound
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  constructor(public objesuggestionService: ObjectionSuggestionTypeService,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    private commonFunction: CommonFunction,
    public router: Router) { }

  async ngOnInit() {
    this.displayedCols = [
      { value: "OBJECTION & SUGGESTION TYPE ID", lowercaseValue: "pkOstid", displayName: "Id" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "DEPARTMENT", lowercaseValue: "departmentName", displayName: "Department" },
      { value: "OBJECTION/SUGGESTION", lowercaseValue: "osType", displayName: "Objection/Suggestion" },
      { value: "OBJECTION/SUGGESTION TYPE", lowercaseValue: "objectionSuggestion", displayName: "Objection/Suggestion Type" },
    ];
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.dataSource.paginator = this.paginator;
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    
    //load all self grievance
    this.displayProgressSpinner();
    const response: any = await this.objesuggestionService.loadObjectionSuggestionType()
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            this.loading = false
            // var created_date = response[i].createdOn
          var created_date = (response[i].createdOn!=null && response[i].createdOn.includes("+"))?response[i].createdOn.split("+")[0]:response[i].createdOn
            let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
            const customObj = new ObjectionSuggestionList();
            customObj.pkOstid = response[i].pkOstid
            customObj.boardName = response[i].boardName
            customObj.departmentName = response[i].departmentName
            customObj.osType = response[i].osType
            customObj.createdOn = created_on
            customObj.objectionSuggestion = response[i].objectionSuggestion
            this.objectionSuggestionList.push(customObj)
          }
          this.dataSource.data = this.objectionSuggestionList;
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.objectionSuggestionList = []
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
    this.displayedColumns = this.displayedCols.map((col) => col.value);
  }


  updateObjSuggestionType(objsugId) {
    this.router.navigate(['secure/update-objection-suggestion-list/' + objsugId])
  }

  deleteObjSuggestionType(objsugId) {
    const data = {
      'osId': objsugId
    }
    const dialogRef = this.dialog.open(CloseGrievanceDialogComponent, {
      width: 'fit-content',
      data: { id: 'isObjDelete' },
    });
    dialogRef.afterClosed().subscribe(async result => {
      var returnval = result;
      if (returnval == ProjectConstants.noMsg) {
        // this.grievanceType = false
      } else {
        // this.grievanceType = true
        this.displayProgressSpinner();
        const response: any = await this.objesuggestionService.deleteOSType(data)
        this.progressSpinnerDialog.close()
        if (response != null && !response.error) {
          if (response.status === ProjectConstants.responseStatusSuccess) {
            await this.commonFunction.successToast(ProjectConstants.objSuggestionDeleteSuccessMsg, false, "")
            window.location.reload()
            this.router.navigate(['secure/objection-suggestion-type-list'])
          } else if (response.status == ProjectConstants.responseStatusFailure) {
            if (response.code == ProjectConstants.gtypeIsinuseStatusCode) {
              await this.commonFunction.successToast(ProjectConstants.objSuggestionIsinUseStatus, false, "")
            } else {
              await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
            }
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      }
    });
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  applyFilter(search: any) {
    const filterValue = search;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    const filterValue = ''
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
